import React from 'react';
export const additionalSteps = {
	transactions: {
		element: '#postpe-home-latest-transactions',
		title: 'view transaction history',
		intro: 'all your bharatpe spends will be shown here',
		position: 'auto',
		tooltipClass: 'latest-transactions-tooltip',
	},
	cashback: {
		element: '#postpe-home-cashback',
		title: 'cashbacks!',
		intro: 'know how much cashback you currently have',
		position: 'auto',
	},
	referral: {
		element: '#postpe-home-refer-friends',
		title: 'refer and earn',
		intro: 'and start earning 5% cashback on your bharatpe spends',
		position: 'auto',
		tooltipClass: 'refer-friends-tooltip',
	},
	spendingLimit: {
		element: '#postpe-home-unlock-spending-limit',
		title: 'postpe spending limit',
		intro: 'unlock your maximum bharatpe spending limit',
		position: 'auto',
	},
	cardDeliveryStatus: {
		element: '#postpe-home-card-delivery-status',
		title: 'view more',
		intro: 'profile, settings, issues, t&c, and a lot more... ',
		position: 'auto',
	},
};

export const steps = [
	{
		target: '#postpe-home-balance-card',
		title: 'postpe limit unlocked',
		content: 'Available and used limit is shown here',
		hideCloseButton: true,
		disableBeacon: true,
		showSkipButton: true,
		placement: 'bottom-start',
	},

	{
		target: '#postpe-home-qr-button',
		title: 'scan and pay',
		content: 'scan any bharatpe qr and pay using bharatpe limit',
		hideCloseButton: true,
		disableBeacon: true,
		showSkipButton: false,
		styles: {
			spotlight: {
				width: '70px !important',
				height: '70px !important',
				transform: 'translate(-50%,-50%) !important',
				top: 'calc(100% - 60px) !important',
				left: 'calc(50% + 1px) !important',
				borderRadius: '50%',
			},
		},
	},
	{
		target: '#postpe-home-send-money-button',
		title: 'send money',
		content: 'to your bank account',
		hideCloseButton: true,
		disableBeacon: true,
		showSkipButton: false,
	},

	{
		target: '#send-money-pro-block',
		title: 'postpe loans',
		content: 'instant cash upto ₹2,00,000 apply today and enjoy flexible repayment options',
		hideCloseButton: true,
		disableBeacon: true,
		showSkipButton: true,
		placement: 'bottom-start',
	},

	{
		target: '#postpe-home-bill-generated',
		title: 'bill generated on 1st of next month',
		content:
			'monthly transactions get billed on 1st of next month. pay in full or convert to 3/4/5/6 month EMIs by 5th of the month to keep enjoying bharatpe',
		hideCloseButton: true,
		disableBeacon: true,
		showSkipButton: false,
		placement: 'bottom',
	},
	{
		target: '#postpe-home-profile-button',
		title: 'view more',
		content: 'profile, settings, issues, t&c and a lot more...',
		hideCloseButton: true,
		disableBeacon: true,
		showSkipButton: false,
	},
	{
		target: '#postpe-user-icon',
		title: 'view more',
		content: 'profile, settings, issues, t&c and a lot more...',
		hideCloseButton: true,
		disableBeacon: true,
		showSkipButton: false,
	},
];
